import { FormEvent, ChangeEvent, ReactElement } from "react";
import { Button } from "@justworkshr/milo-core";
import { Form } from "@justworkshr/milo-form";
import EditProfileEmailInput from "../editProfileEmailInput/EditProfileEmailInput";
import styles from "./edit-profile-email-form.module.css";

const EditProfileEmailForm = ({
  emailInput,
  savedEmail,
  inlineError,
  isLoading,
  onChange,
  onSubmit,
}: {
  emailInput: string;
  savedEmail: string;
  inlineError: string;
  isLoading: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
}): ReactElement => {
  return (
    <Form onSubmit={onSubmit}>
      <div className={styles.editEmailInput}>
        <EditProfileEmailInput
          email={savedEmail}
          label={"Current personal email"}
          disabled={true}
        />
      </div>
      <div className={styles.editEmailInput}>
        <EditProfileEmailInput
          email={emailInput}
          label={"New personal email"}
          inlineError={inlineError}
          disabled={false}
          onChange={onChange}
        />
      </div>
      <div className={styles.submitButton}>
        <Button type="submit" variant="filled" loading={isLoading}>
          Save
        </Button>
      </div>
    </Form>
  );
};

export default EditProfileEmailForm;
